import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".bottomspace-library--p22Lv {\n  margin-bottom: 10rem;\n}";
var styles = {"bottomspace":"bottomspace-library--p22Lv"};
styleInject(css_248z);

export { styles as default };
